import React, { Component } from 'react'  
import axios from 'axios'
import Scroll from 'react-scroll'
import createHistory from 'history/createBrowserHistory'
import { API_MENU_ES, API_MENU_EN } from '../../utils/apiEndpoints.js'
import info from '../../utils/info'

let Link = Scroll.Link;

class Menu extends Component {
	state = {
		apiMenu: [],
		apiES: API_MENU_ES,
		apiEN: API_MENU_EN,
		pathES: '',
		pathEN: ''
	}

	// Get API endpoint
	getEndpoint() {
		const fullURL = window.location.host + window.location.pathname;

		if (fullURL.split('/')[1] !== 'en') {
			const endPoint = this.state.apiES;
			return endPoint;

		} else if (fullURL.split('/')[1] === 'en') {
			const endPoint = this.state.apiEN;
			return endPoint;
		}
	}

	// Switch language between sections
	switchLang() {
		const history = createHistory();
		const slug = history.location.pathname;

		if (slug === '/' || slug === '/en' || slug === '/en/') {
			this.setState(() => {
				return {
					pathES: '/',
					pathEN: '/en'
				}
			})
		} 
	}

	//Menu
	apiMenu() {
		axios.get(this.getEndpoint()).then(response => {
			const arr = response.data.map((el) => { return el });
			this.setState({ apiMenu: arr });
		}).catch(err => console.log(err));
	}

	itemMenu(el) {
		return (
			<li className="menu-item" key={el.ID}>
				<Link
					activeClass="active"
					to={el.url}
					smooth={true}
					duration={650}
					offset={-110} 
					onClick={this.props.activeMenu}
				>
					{el.title}
				</Link>
			</li>
		)
	}

	componentDidMount() {
		this.getEndpoint();
		this.apiMenu();
		this.switchLang();
	}

	componentWillReceiveProps() {
		this.apiMenu();
		this.switchLang();
	}

	render() {
		return (
			this.props.isActive && 
			<nav className="menu menu-active">
				<div className="hero-body">
					<div className="container has-text-centered">
						<ul>
							{this.state.apiMenu.map(el => this.itemMenu(el))}
							<li>
								<a href="http://acuriorestaurantes.net/trabaja-con-nosotros/">
									{this.props.lang === "es" ? info.es.trabaja : info.en.trabaja}
								</a>
							</li>
						</ul>
					</div>
				</div>
			</nav>
		)
	}
}

export default Menu;